import styled from 'styled-components/native'

import { TOOLKIT_TYPE } from '@lyrahealth-inc/shared-app-logic'

import { ThemeType } from '../../utils'

export const WellnessToolkitMainContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  'min-width': theme.breakpoints.isMinWidthLaptop ? '964px' : theme.breakpoints.isMinWidthTablet ? '700px' : '311px',
  margin: theme.breakpoints.isMobileSized ? 0 : 'auto',
  paddingLeft: theme.breakpoints.isMobileSized ? '16px' : 0,
  paddingRight: theme.breakpoints.isMobileSized ? '16px' : 0,
  'max-width': theme.breakpoints.isMinWidthTablet ? '700px' : '100%',
}))

export const getPromotionTitle = (promotion: TOOLKIT_TYPE) => {
  return `My ${promotion}`
}
